<template>
    <div>
        <top-bar></top-bar>
        <div class="home-content">
            <div class="msg-landing">{{lbl.home.title}}</div>
            <div class="img-logo">
                <img src="@/assets/img/01-register/logo-landing@3x.png"/>
            </div>
            <div class="msg-landing">{{lbl.home.enjoy_privilege}}</div>

            <div class="row no-gutters p-3">
                <div class="col-4">
                    <div class="img-item">
                        <img src="@/assets/img/01-register/fragrance-icon@3x.png"/>
                    </div>
                    <div class="text-item">
                        {{lbl.home.product_info}}
                    </div>
                </div>
                <div class="col-4">
                    <div class="img-item">
                        <img src="@/assets/img/01-register/calendar-icon@3x.png">
                    </div>
                    <div class="text-item">
                        {{lbl.home.special_event}}
                    </div>
                </div>
                <div class="col-4">
                    <div class="img-item">
                        <img src="@/assets/img/01-register/gift-icon@3x.png">
                    </div>
                    <div class="text-item">
                        {{lbl.home.gift}}
                    </div>
                </div>
            </div>

            <div class="wrap-btn">
                <router-link to="/register" class="btn-black">{{lbl.home.continue}}</router-link>
            </div>
        </div>

        <modal view="home"
               :busModal="busModal"
               @modalAlertHidden="onHideModalAlert($event)"></modal>
    </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Vue from "vue";
import Locale from "@/helper/locale/locale.js";
import Account from "@/helper/AccountHelper.js";
import Modal from "@/components/modal/Modal.vue";
import TopBar from "@/components/TopBar.vue";

export default {
    name: "home",
    components: {
        Modal,
        TopBar
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),
            isLogin: false,
            profile: {},

            busModal: new Vue(),
        };
    },
    created: function() {
        Account.loginStatus().then((status) => {
            this.isLogin = status;
            if (status) {
                this.profile = Account.getCacheProfile();
            }
        });
        // Vue.ga.screenName(this, 'Home');
        // Vue.ga.event(this, "new cat", "view page", "home label");

    },
    methods: {
        switchLang: function(locale) {
            Account.apiUpdateProfileLocale(locale)
                .then(profile => {
                    if (profile)
                        this.profile = profile;

                    Locale.setLocale(locale);
                    this.lbl = Locale.getLbl();
                })
                .catch((error) => {
                    if (error.response) {
                     console.log(error);
                    } else {
                        console.log(error);
                        this.showErrorConnectModal();
                        // this.isInternetConnected = false;
                    }
                });
        },
        showErrorConnectModal: function() {

            var configModal = {
              
                message: this.lbl.error_connect.message,
                strBtnOk: this.lbl.error_connect.btn_close,
            };
            this.busModal.$emit('showErrorConnectModal', configModal);
        },
    },
};
</script>
<style lang="scss" scoped>
    @import "@/style/page/home.scss";
</style>
